/**
 * Types of folderable app UIs.
 */
export var FolderableAppType;
(function (FolderableAppType) {
    // Folderable items can be selected through a modal
    FolderableAppType["MODAL"] = "modal";
    // Folderable items are rendered as a list
    FolderableAppType["LIST_PAGE"] = "list_page";
})(FolderableAppType || (FolderableAppType = {}));
